// Once Sources is clicked, give users a bounded intent-to-act window before hiding.
export const FOURTEEN_DAYS_MS: number = 14 * 24 * 60 * 60 * 1000;
